import { notNill } from '@kwenta/sdk/utils'
import { useMemo } from 'react'
import { optimism, optimismSepolia } from 'viem/chains'

import Connector from 'containers/Connector'

const useIsL2 = () => {
	const { activeChain } = Connector.useContainer()
	const isL2 = useMemo(
		() =>
			notNill(activeChain)
				? [optimism.id, optimismSepolia.id].includes(activeChain.id as 10 | 11155420)
				: false,
		[activeChain]
	)
	return isL2
}

export default useIsL2
